import React, { useState } from 'react';
import {
  List,
  Upload,
  Button,
  Table,
  Tag,
  notification,
  Typography,
  Row,
  Col,
  Modal,
  Tooltip,
  Space,
  Form,
  Card
} from 'antd';
import {
  UploadOutlined,
  CheckOutlined,
  CloseOutlined,
  FileTextOutlined,
  EditOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  FieldTimeOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import classes from "../../../Etablissements/Etablissements.module.css";

const { Title, Text } = Typography;

const TelechargementPvCertifDiplome = () => {
  const { t, i18n } = useTranslation();

  const [participants, setParticipants] = useState([
    {
      id: 1,
      nom: 'NOM 1',
      prenom: 'Prenom 1',
      email: 'nom1@mail.com',
      dateNaissance: '15/10/2004',
      cin: '14407380',
      niveau: 'Bac',
      status: 'pending',
      diploma: null
    },
    {
      id: 2,
      nom: 'Nom 2',
      prenom: 'Prenom 2',
      email: 'nom2@mail.com',
      dateNaissance: '15/10/2000',
      cin: '15203698',
      niveau: 'Licence',
      status: 'pending',
      diploma: null
    },
    {
      id: 3,
      nom: 'Nom 3',
      prenom: 'Prenom 3',
      email: 'nom3@mail.com',
      dateNaissance: '15/10/2000',
      cin: '15203699',
      niveau: 'Licence',
      status: 'pending',
      diploma: null
    }
  ]);

  const [pvFile, setPvFile] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentParticipantId, setCurrentParticipantId] = useState(null);
  const [selectedDiplomaFile, setSelectedDiplomaFile] = useState(null);

  const showUploadModal = (participantId) => {
    const participant = participants.find(p => p.id === participantId);
    setCurrentParticipantId(participantId);
    setSelectedDiplomaFile(participant.diploma || null);
    setModalVisible(true);
  };

  const handleModalOk = () => {
    if (selectedDiplomaFile) {
      const updated = participants.map(p =>
        p.id === currentParticipantId
          ? { ...p, status: 'accepted', diploma: selectedDiplomaFile }
          : p
      );
      setParticipants(updated);
      const participant = updated.find(p => p.id === currentParticipantId);
      notification.success({
        message: `Diplôme ajouté pour ${participant.prenom} ${participant.nom}`
      });
      setModalVisible(false);
      setCurrentParticipantId(null);
      setSelectedDiplomaFile(null);
    } else {
      notification.error({
        message: "Veuillez téléverser un document avant d'ajouter."
      });
    }
  };

  const handleRefuse = (id) => {
    const updated = participants.map(p =>
      p.id === id ? { ...p, status: 'refused', diploma: null } : p
    );
    setParticipants(updated);
    const participant = updated.find(p => p.id === id);
    notification.warning({
      message: `Participant ${participant.prenom} ${participant.nom} refusé.`
    });
  };

  const handleDiplomaUpload = (file) => {
    setSelectedDiplomaFile(file);
    return false;
  };

  const renderStatusTag = (status) => {
    switch (status) {
      case 'accepted':
        return <Tag color="#26b6a7">Accepté</Tag>;
      case 'refused':
        return <Tag color="#ff808b">Refusé</Tag>;
      default:
        return <Tag color="#ffb836">À vérifier</Tag>;
    }
  };

  const columns = [
    { title: 'Nom', dataIndex: 'nom', key: 'nom' },
    { title: 'Prénom', dataIndex: 'prenom', key: 'prenom' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Date de naissance', dataIndex: 'dateNaissance', key: 'dateNaissance' },
    { title: 'CIN', dataIndex: 'cin', key: 'cin' },
    { title: 'Niveau', dataIndex: 'niveau', key: 'niveau' },
    {
      title: 'Statut',
      key: 'status',
      render: (_, record) => renderStatusTag(record.status)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            icon={record.diploma ? <EditOutlined /> : <CheckOutlined />}
            type="text"
            onClick={() => showUploadModal(record.id)}
            style={{color:"#26b6a7"}}
          >
            {record.diploma ? 'Modifier' : 'Accepter'}
          </Button>
          <Button 
           style={{color:"#ff808b"}}
           icon={<CloseOutlined />} type="text" onClick={() => handleRefuse(record.id)}>
            Refuser
          </Button>
          {record.status === 'accepted' && record.diploma && (
            <Tooltip title="Voir diplôme">
              <FileDoneOutlined
                style={{ cursor: 'pointer', color: "#025cab" }}
                onClick={() => window.open(URL.createObjectURL(record.diploma))}
              />
            </Tooltip>
          )}
        </Space>
      )
    }
  ];

  const sectionTitleStyle1 = {
    fontSize: "22px",
    fontWeight: 600,
    color: "#6197cb",
    textAlign: i18n?.dir() === "ltr" ? "left" : "right"
  };
  const sectionTitleStyle2 = {
    fontSize: "22px",
    fontWeight: 600,
    color: "#6197cb",
    textAlign: i18n?.dir() === "ltr" ? "left" : "right",
    marginBottom: "20px"
  };

  return (
    <div>
      <Row className={classes.listeRow}>

      <List
        className={classes.listeCard}
        header={
        
        <h2  style={{ color: '#2A96FF' }}>{t("Informations de la Formation")}</h2>
      
      }
        bordered = {false}
        style={{ marginBottom: 15 , backgroundColor:"white" , padding:"24px", borderRadius: "8px 8px 8px 8px"}}
      >
        <div style={{paddingInline:"20px"}}>
        <List.Item>
          <FileTextOutlined style={{ marginRight: 8 }} />
          <strong>Formation :</strong>&nbsp; Formation XXX
        </List.Item>
        <List.Item>
        <FileProtectOutlined  style={{ marginRight: 8 }} />
          <strong>Diplôme :</strong>&nbsp; Certificat d'Aptitude Professionnelle (CAP) - شهادة الكفاءة المهنية
        </List.Item>
        <List.Item>
        <FieldTimeOutlined  style={{ marginRight: 8 }} />
          <strong>Date de début :</strong>&nbsp; 15/10/2025
        </List.Item>
        <List.Item>
        <FieldTimeOutlined  style={{ marginRight: 8 }} />
          <strong>Date de fin :</strong>&nbsp; 15/10/2026
        </List.Item>
        <List.Item>
          <Form.Item
            label="PV"
            name="copie_programme_formation"
            rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            style={{ marginBottom: 0 }}
          >
            <Upload
              name="copie_programme_formation"
              beforeUpload={(file) => {
                setPvFile(file);
                return false;
              }}
              showUploadList={pvFile ? [{ name: pvFile.name }] : false}
              accept="jpg,.jpeg,.png,.pdf"
            >
              <Button icon={<UploadOutlined />}>Téléverser le PV</Button>
            </Upload>
          </Form.Item>
        </List.Item>

        </div>
      
      </List>

      {/* ========== SECTION PARTICIPANTS ========== */}
        <Card className={classes.listeCard} bordered={false}>
        <h2  style={{ color: '#2A96FF' }}>{t("Liste des participants")}</h2>
          <Table
            dataSource={participants}
            columns={columns}
            rowKey="id"
            pagination={false}
          />
        </Card>
      </Row>

      {/* ========== MODAL TÉLÉVERSEMENT DIPLÔME ========== */}
      <Modal
        title="Téléverser le diplôme du participant"
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={() => setModalVisible(false)}
        okText="Ajouter"
        cancelText="Annuler"
      >
        <Form.Item
          label="Diplôme"
          name="diplome"
          rules={[{ required: true, message: "Veuillez téléverser un diplôme." }]}
        >
          <Upload
            beforeUpload={handleDiplomaUpload}
            showUploadList={selectedDiplomaFile ? [{ name: selectedDiplomaFile.name }] : false}
          >
            <Button icon={<UploadOutlined />}>Téléverser diplôme</Button>
          </Upload>
        </Form.Item>
      </Modal>

    </div>
  );
};

export default TelechargementPvCertifDiplome;
